export default __webpack_public_path__ + "static/media/DocCallOnIcon.91c2af85.svg";